import { Box, BoxProps, Text, useMultiStyleConfig, Wrap } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { StylesProvider } from './Navigator';

type Props = PropsWithChildren<{
  title?: string
}> & BoxProps;

export default function NavigatorGroup({ title, children, ...props }: Props) {
  const styles = useMultiStyleConfig('Navigator');
  //const styles = useStyles();
  return (
    <Box __css={styles.navigatorGroup} {...props}>
      {!!title && <Text as="span">{title}</Text> }
      <StylesProvider value={styles}>
        <Wrap>
          {children}
        </Wrap>
      </StylesProvider>
    </Box>
  )
}
